import { Radio, RadioList, Text } from "@ucl/react-library";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useBoundInput } from "src/hooks/use-bound-input";
import { SelectTile } from "../select-tile/select-tile";

export enum HowToProceedOptions {
  ACCEPT="accept",
  CHALLENGE="challenge"
}

export const HowToProceed = ({canChallenge}: {canChallenge: boolean}) => {
  const { t } = useTranslation("translation", { keyPrefix: "howToProceed" });

  const { control } = useFormContext();
  const howToProceedProps = useBoundInput({ name: "howToProceed", control });

  if (!canChallenge) {
    return (
      <div className="flex flex-col gap-5 max-w-[540px]" data-testid="howToProceedComponent">
        <Text renderAs="h2" styleType="h4" fontWeight="semi-bold">
          {t("cantChallengeTitle")}
        </Text>
        <Text size={"large"} renderAs={"p"}>{t("acceptCantChallenge")}</Text>
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-5 max-w-[540px]" data-testid="howToProceedComponent">
      <Text renderAs="h2" styleType="h4" fontWeight="semi-bold">
        {t("title")}
      </Text>
      <RadioList variant="tile" size="large" {...howToProceedProps}>
        <Radio
          label={t("acceptRadio")}
          value={HowToProceedOptions.ACCEPT}
          className="flex flex-col-reverse !items-start"
          data-testid="acceptRadio"
        >
          <SelectTile title={t("acceptTitle")} description={[t("acceptPara")]} />
        </Radio>
        <Radio
          label={t("challengeRadio")}
          value={HowToProceedOptions.CHALLENGE}
          className="flex flex-col-reverse !items-start"
          data-testid="challengeRadio"
        >
          <SelectTile title={t("challengeTitle")} description={[t("challengePara"), t("challengePara1")]} />
        </Radio>
      </RadioList>
    </div>
  );
};
